import React from "react";
import SubNav from "../../../Shared/SubNav";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../../../context/socket";

const InvestingBelief = () => {
  const location = useLocation();
  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const navigate = useNavigate();
    


    const handleNext = () => {
      const nextUrl = "/priorities?clientId=" + roomId;
      const nextUrl2 = "/priorities";

     
      socket.emit("navigate", { room: roomId, url: nextUrl2 });
      navigate(nextUrl);
    };
  
    const handleBack = () => {
      const prevUrl = "/key-action-points?clientId=" + roomId; 
      const prevUrl2 = "/key-action-points?clientId=" + roomId; 

      socket.emit("navigate", { room: roomId, url: prevUrl2 });
      navigate(prevUrl); 
    };
  return (
    <>
      <div className="container minht">
        <div className="row">
          <div className="col">
            <h2>Why does this matter?</h2>
          </div>
        </div>
        <div className="row pt-4">
          <div className="col-md-1 d-none d-md-block">
            <img src="assets/images/falling-coins.svg" alt="" />
          </div>
          <div className="col-md-11">
            <p className="fs-21">
              At<span className="clrgreen fw-bold"> FinEdge</span>, one of our core
              beliefs is that long term wealth can only be created by following
              a  robust investing process.
            </p>
            <ul className="fs-21">
              <li className="my-3 lh-base">
                We believe that a disciplined and goal-based approach to
                investing is far more important than investing in “fancy”
                products, trying to time the market or fixating too heavily on
                investing costs.
              </li>
              <li className="mb-3 lh-base">
                We believe that the traditional approach to risk profiling is
                not very efficient, because it assigns a risk profile to a
                person, instead of a goal. For example: the same person should
                choose low-risk assets if their goal is 3 years away, but invest
                in high growth assets for their retirement.
              </li>
            </ul>
            <p className="fs-21">
              Understanding your{" "}
              <span className="clrgreen fw-bold">Investing Beliefs</span> will allow
              us to be aligned as we move ahead together on your investing
              journey!
            </p>
          </div>
          <div className="col-md-1 d-block d-md-none mt-4">
            <img src="assets/images/falling coins-mo.png" alt="" />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row py-4">
          <div className="col text-end">
          <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvestingBelief;
